import React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Link } from 'react-router-dom';
import { CatalogProducts } from './CatalogProducts';
import { CatalogGroups } from './CatalogGroups';
import { SimplePageTitle } from '@/components/layout/PageTitle';
import { Tabs } from '@ygtechnologies/rubus-ui';

const tabs = [
    {
        id: 'products',
        name: <Trans>All products</Trans>,
        render: () => <CatalogProducts />,
    },
    {
        id: 'groups',
        name: <Trans>Product groups</Trans>,
        render: () => <CatalogGroups />,
    },
];

interface CatalogProps {
    tab: 'products' | 'groups';
}

const Catalog: React.FC<CatalogProps> = ({ tab }) => {
    const activeTab = tabs.find((t) => t.id === tab) ?? tabs[0];

    return (
        <div>
            <SimplePageTitle title={t`Products`} />

            <Tabs.Container activeId={tab} variant="underline" sticky>
                {tabs.map((t) => (
                    <Tabs.Tab key={t.id} id={t.id} as={Link} to={`/catalog/${t.id}`} label={t.name} />
                ))}
                <Tabs.Content>{activeTab.render()}</Tabs.Content>
            </Tabs.Container>
        </div>
    );
};

export default Catalog;
